TS.ns('WL');


WL.leasingOfferClientModel = new Class({
    Extends: WL.leasingOfferBaseModel,

    initialize: function (config) {
        var me = this;
        me.parent(config);
    },

    createProperties: function (config) {   
        var me = this;          

        me.parent(config);

        var clientList = me.getDomainProperty('browseClient_Property');
        if (clientList != null) {
            clientList.un('selectionChanged', me.onClientChanged, me);
            clientList.on('selectionChanged', me.onClientChanged, me);
            clientList.on('reset', me.onClientIdReset, me);
        }

        me.watchProperty(me.Document.ClientUniqueIDOnDocument, me.onClientUniqueIDChanged, me); 

        me.partnerTypeReadOnly = ko.computed(function () {
            if (me.Document.ClientId() == 0 || me.Document.ClientId() == null)
                return false;
            return true;
        });
    },

    onClientIdReset: function (newValue) {
        var me = this;

        me.partnerTypeReadOnly = ko.computed(function () {
            if (me.Document.ClientId() == 0 || me.Document.ClientId() == null)
                return false;
            return true;
        });
    },

    onClientChanged: function (selectedPartner) {
        var me = this;

        me.isPartnerChanging = true;

        if (selectedPartner.sender.SelectedItem() == null) {
            me.Document.PartnerTypeId(null);
            me.Document.PartnerTypeName(null);  
            me.Document.ClientUniqueIDOnDocument(null);
            me.isPartnerChanging = false;
        }
        else {
            setTimeout(function () {
                me.Document.PartnerTypeId(selectedPartner.sender.SelectedItem().PartnerTypeId);
                me.Document.PartnerTypeName(selectedPartner.sender.SelectedItem().PartnerTypeName);
                me.Document.ClientUniqueIDOnDocument(selectedPartner.sender.SelectedItem().UniqueID);
                me.Document.ClientNameOnDocument(null);
                me.performServerCommand('RefreshRequiredDocumentType', true);
                me.isPartnerChanging = false;  
            }, 0); 
        }
    },

    onClientUniqueIDChanged: function (newValue) {
        var me = this;

        if (me.isPartnerChanging === true)
            return;

        me.performServerCommand('SearchPartner', true);

        me.partnerTypeReadOnly = ko.computed(function () {
            if (me.Document.ClientId() == 0 || me.Document.ClientId() == null)
                return false;
            return true;
        });
    },

    _setData: function (data) {
        var me = this;
        try {
            me.settingData = true;
            me.parent(data);
        }
        finally {
            me.settingData = false;
        }

    }

});

